import React, { Component } from 'react';
import './questions.css';
import { Slider, Form, Button, Row, Col, Modal } from 'antd';
import selfIamge from '../static/self4-image.png';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Translate from "../translate/Translate";
import {
    questionsList,
    questionsSubmit
} from '../../modules/questions';
import { translationResultGet } from '../../modules/translate';
import result from '../../modules/result';


class FormSelf extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionData: null,
            loading: false,
            ansValue: [0, 0, 0, 0, 0, 0],
            warningModal: {
                title: null,
                description: null,
                confirm: null,
                cancel: null
            }
        }
    }


    componentDidMount() {
        translationResultGet("questions.self.warning.title").then(
            (data) => {
                this.setState({
                    warningModal: {
                        ...this.state.warningModal,
                        title: data
                    }
                })
                translationResultGet("questions.self.warning.confirm").then(
                    (data) => {
                        this.setState({
                            warningModal: {
                                ...this.state.warningModal,
                                confirm: data
                            }
                        })
                        translationResultGet("questions.self.warning.cancel").then(
                            (data) => {
                                this.setState({
                                    warningModal: {
                                        ...this.state.warningModal,
                                        cancel: data
                                    }
                                })
                                translationResultGet("questions.self.warning.description").then(
                                    (data) => {
                                        this.setState({
                                            warningModal: {
                                                ...this.state.warningModal,
                                                description: data
                                            }
                                        })
                                    }
                                )
                            }
                        )
                        
                    }
                )
                
            }
        )
        

        if (!this.props.questionsData) {
            this.getQuestions();
            // console.log(this.props.questionsData)
        }
        else {
            if (this.props.questionsData.progress == "self1") {
                // this.setState({
                //     questionData: {
                //         trad: {
                //             title: "自我評估",
                //             intro: "與同年齡的其他人士相比，請評估你以下每項能力，給予適當的分數。請準確地評估你對自己的看法；盡量避免在每項能力給予相同的評分。",
                //             choices: ["手工技巧", "數學技巧", "音樂技巧", "對他人的瞭解", "管理技巧", "辦公室技巧"],
                //             //R,I,A,S,E,C
                //             sliderLable: ["低", "高"]
                //         }
                //     }
                // })
            }
            else {
                if (this.props.questionsData.progress == "self2") {
                    // this.setState({
                    //     questionData: {
                    //         trad: {
                    //             title: "自我評估",
                    //             intro: "與同年齡的其他人士相比，請評估你以下每項能力，給予適當的分數。請準確地評估你對自己的看法；盡量避免在每項能力給予相同的評分。",
                    //             choices: ["機械能力", "科學能力", "藝術能力", "教導能力", "銷售能力", "文書能力"],
                    //             //R,I,A,S,E,C
                    //             sliderLable: ["低", "高"]
                    //         }
                    //     }
                    // })
                }
                else {
                    this.props.formSubmit();
                }
            }
        }
    }

    componentWillMount() {
        if (this.props.questionsData.progress == "self1") {
            // this.setState({
            //     questionData: {
            //         trad: {
            //             title: "自我評估",
            //             intro: "與同年齡的其他人士相比，請評估你以下每項能力，給予適當的分數。請準確地評估你對自己的看法；盡量避免在每項能力給予相同的評分。",
            //             choices: ["手工技巧", "數學技巧", "音樂技巧", "對他人的瞭解", "管理技巧", "辦公室技巧"],
            //             //R,I,A,S,E,C
            //             sliderLable: ["低", "高"]
            //         }
            //     }
            // })
        }
        else {
            if (this.props.questionsData.progress == "self2") {
                // this.setState({
                //     questionData: {
                //         trad: {
                //             title: "自我評估",
                //             intro: "與同年齡的其他人士相比，請評估你以下每項能力，給予適當的分數。請準確地評估你對自己的看法；盡量避免在每項能力給予相同的評分。",
                //             choices: ["機械能力", "科學能力", "藝術能力", "教導能力", "銷售能力", "文書能力"],
                //             //R,I,A,S,E,C
                //             sliderLable: ["低", "高"]
                //         }
                //     }
                // })
            }
            else {
                this.props.formSubmit();
            }
        }
    }

    handleChange = (i, value) => {
        this.setState(state => {
            const ansValue = state.ansValue.map((item, j) => {
                if (j === i) {
                    return value;
                } else {
                    return item;
                }
            });
            return {
                ansValue,
            };
        });
    };

    sendData = () => {
        // console.log("send")
        let resultData = {
            "category": this.props.questionsData.progress,
            // "lastQuestionNumber": this.props.questionsData.questions[6].questionNumber,
            "result": {
                "R": 0,
                "I": 0,
                "A": 0,
                "S": 0,
                "E": 0,
                "C": 0,
            }
        }

        resultData.result.R = this.state.ansValue[0]
        resultData.result.I = this.state.ansValue[1]
        resultData.result.A = this.state.ansValue[2]
        resultData.result.S = this.state.ansValue[3]
        resultData.result.E = this.state.ansValue[4]
        resultData.result.C = this.state.ansValue[5]

        this.props.questionsSubmit(resultData).then(
            (res) => {
                if (res) {
                    // console.log("success")
                    this.setState({ loading: false, errormessage: null });
                    this.props.formSubmit();
                } else {

                    this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
                }
            },
            (err) => {
                // console.log("error")
                this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
                // this.formRef.current.resetFields();
            }
        );
        this.props.formSubmit();
    };

    findDuplicates = arr => {
        let duplicate = arr.filter((item, index) => arr.indexOf(item) != index)
        if (duplicate.length > 0) return true
        else return false
    };

    actFormSubmit = form => {
        this.setState({ loading: true });
        // console.log(this.state.ansValue)
        if (this.findDuplicates(this.state.ansValue)) {
            // console.log(this.state)
            Modal.confirm({
                title: this.state.warningModal.title[this.props.language],
                content: this.state.warningModal.description[this.props.language],
                zIndex:2000,
                cancelText: this.state.warningModal.confirm[this.props.language],
                onCancel:()=>{this.sendData()},
                okText: this.state.warningModal.cancel[this.props.language],
                onOk:()=>{},

            });
        }
        else {

            this.sendData()
        }
    };

    render() {
        const data = {
            trad: {
                submit: "下一步"
            }
        };
        const { questionData } = this.state;

        return (
            <div className="formContainer">
                <div className="questionImageContainer selfBgColor">
                    <img src={selfIamge} className="questionImage"></img>
                    <h1><Translate id="questions.self.title"/></h1>
                </div>
                <div className="questionFormContainer">
                    <Form onFinish={this.actFormSubmit} name="dreamForm" validateMessages="Field is required!">
                        <div className="form lightFont">
                            <div>
                            <Translate id="questions.self.description"/>
                            </div>

                            {[...Array(6)].map((_, i)  =>
                                <Row key={i} className="formItemSlider">
                                    <Col className="darkFont formLable">
                                        <span ><Translate id={`questions.${this.props.questionsData.progress}.choice${i+1}`}/></span>
                                    </Col>
                                    <Col className="sliderLable">
                                        <span ><Translate id="questions.self.low"/></span>
                                    </Col>
                                    <Form.Item name={`questions.${this.props.questionsData.progress}.choice${i+1}`}>
                                        <Slider className="sliderItem" min={0} max={7} tooltipVisible onChange={this.handleChange.bind(this, i)} />
                                    </Form.Item>
                                    <Col className="sliderLable">
                                        <span ><Translate id="questions.self.high"/></span>
                                    </Col>

                                </Row>
                            )}

                            <div className="submitBtnContainer">
                                <input type="submit" className="radioSubmitBtn" value={data["trad"].submit} />
                            </div>
                        </div>
                    </Form>
                </div>


            </div>
        )
    }
}

const mapStateToProps = state => ({
    questionsData: state.questions.questionsData,
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            questionsList,
            questionsSubmit
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FormSelf);